export const Bio = {
  name: "Amine AIT MOKHTAR",
  roles: [
  
    "Développeur FullStack",
  ],
  description:
  "Passionné par le développement fullstack, j'utilise des technologies comme React, Bootstrap et TailwindCSS pour créer des interfaces modernes et intuitives. Ayant une solide expérience en back-end avec Laravel et Symfony, je développe des applications robustes et performantes, tout en portant une attention particulière à l'UX/UI.",
  github: "https://github.com/amine-aitmokhtar",
  resume:"/pdf/CV.pdf",
  linkedin: "https://www.linkedin.com/in/amine-ait-mokhtar-932227227/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      
      
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },

      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },

      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },

 
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      }, 
      {
        name: "Laravel",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Laravel.svg/640px-Laravel.svg.png",
      },
      {
        name: "Symfony",
        image:
        "https://symfony.com/logos/symfony_black_03.png" },
 
      {
        name: "Django",
        image:"https://cdn.worldvectorlogo.com/logos/django.svg"     },
      
   
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Langage de programmation ",
    skills: [

      {
        name: "C",
        image:
"https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/C_Language_Logo.svg/640px-C_Language_Logo.svg.png"      },

      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Matlab",
        image:
"https://upload.wikimedia.org/wikipedia/commons/2/21/Matlab_Logo.png"      },
    
    ],
  },
  {
    title: "Environnement et outils",
    skills: [
      {
        name: "Linux",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/3/3c/TuxFlat.svg",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Git",
        image:
        "https://upload.wikimedia.org/wikipedia/commons/3/3f/Git_icon.svg"   },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
     
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "/images/NoLimitClub.png",
    role: "Chef d'Équipe Développement Web – No Limit Club",
    company: "No Limit Club",
    date: "Avril 2023 - Juin 2024",
    desc: "Conception et développement de sites web dynamiques avec React et Laravel, tout en organisant des ateliers de formation sur les frameworks et langages de programmation pour former les participants aux meilleures pratiques et technologies émergentes.",
    skills: [
      "React",
      "Bootstrap",
      "jQuery",
      "Laravel",
      "Github",
      
    ],
    doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  },

  {
    id: 1,
    img: "/images/icosnet.png",
    role: "Stage - Développeur Back-end ",
    company: "Icosnet",
    date: "Mai 2023 - Juin 2023",
    desc: "Création d'outils de visualisation interactifs pour faciliter l'analyse des tendances et performances, optimisant ainsi la stratégie opérationnelle et commerciale.",
    skills: [
      "Python",
      "Django",
    ],
  },
  {
    id: 2,
    img: "/images/Laboratoire.png",
    role: "Développeur Logiciel C  ",
    company: "Laboratoire D'analyse Médicale",
    date: "Mars 2021 - Janvier 2023",
    desc: "Optimisé les algorithmes pour accélérer l'analyse des données médicales tout en concevant et réalisant des tests unitaires et de validation pour assurer la fiabilité.",
    skills: [
      "C",
    ],
  
  },
  
  {
    id: 3,
    img: "/images/gmc.png",
    role: "Formation en intelligence artificielle",
    company: "GO MY CODE",
    date: "Octobre 202 - Février 2023",
    desc: "Optimisé les algorithmes pour accélérer l'analyse des données médicales tout en concevant et réalisant des tests unitaires et de validation pour assurer la fiabilité.",
    skills: [
      "Python","Apprentissage automatique","Apprentissage profond", 
    ],

    doc: "https://drive.google.com/file/d/1d7xKMTG_uWLJzBKCPaU6Zd122rZlQcVr/view?usp=drive_link",
  
  },
  
  
];

export const education = [
  {
    id: 0,
    img: "/images/LeHavre.png", // Tu peux ajouter une image liée à l'université si tu en as une
    school: "Université Le Havre Normandie",
    date: "Septembre 2024 - Juin 2026",
    degree: "Master en Informatique – Ingénierie du Web, des Objets Communicants et des Systèmes Complexes",
    desc: "Actuellement étudiant en Master à l'Université Le Havre Normandie, spécialisé dans l'ingénierie des systèmes complexes et des objets communicants. Ce programme couvre des domaines comme les architectures web avancées, les systèmes IoT, et l'intelligence artificielle.",
  },
  {
    id: 1,
    img: "/images/Alger1.png", // Une image correspondant à l'université d'Alger si disponible
    school: "Université d'Alger 1",
    date: "Septembre 2023 - Juin 2024",
    degree: "Première année de Master en Informatique – Ingénierie des systèmes informatiques intelligents",
    desc: "Études en ingénierie des systèmes intelligents, avec des compétences en développement d'applications et en traitement des données, notamment dans des environnements d'IA et de systèmes intelligents.",
  },
  {
    id: 2,
    img: "/images/logoHIS.png", // Image correspondant à HIS University
    school: "HIS University, Algérie",
    date: "Octobre 2020 - Juillet 2023",
    degree: "Licence en Informatique – Systèmes Informatiques",
    desc: "Diplôme en informatique avec une spécialisation en systèmes informatiques. Au cours de ma formation j'ai acquis des compétences solides en algorithmique, programmation web, gestion et administration de bases de données et l'environnement Linux.",
  },
];


export const projects = [
  {
    id: 0,
    title: "V2-Application de gestion des inscriptions - HIS University",
    date: "Aout 2023 - Octobre 2023",
    description:
      "Développement d'une application web pour la gestion des inscriptions en ligne et le suivi des étudiants. Cette application permet aux étudiants de s'inscrire, de soumettre des documents et de suivre l'avancement de leur dossier. Du côté administratif, elle offre des outils de gestion et de génération de rapports pour faciliter la gestion des inscriptions et du parcours académique.",
    image: "/images/His_site_Amine.png", 
    tags: ["React", "Tailwind", "Laravel", "MySQL"],
    category: "web app",
    github: "https://github.com/amine-aitmokhtar/HIS_UNIVERSITY_V2",
    webapp: "https://his.edu.dz/",
  },

  {
    id: 1,
    title: "V1-Application de gestion des inscriptions - HIS University",
    date: "Février 2022 - Juillet 2023",
    description:
      "Développement d'une application web pour la gestion des inscriptions en ligne et le suivi des étudiants. Cette application permet aux étudiants de s'inscrire, de soumettre des documents et de suivre l'avancement de leur dossier. Du côté administratif, elle offre des outils de gestion et de génération de rapports pour faciliter la gestion des inscriptions et du parcours académique.",
    image: "/images/HISacceuil.png", 
    tags: ["React", "jQuery", "Laravel", "CSS", "MySQL"],
    category: "web app",
    github: "https://github.com/amine-aitmokhtar/HIS_UNIVERSITY_V1",
    webapp: "https://netlify_HIS_University.dz",
  },

  {
  id: 2,
  title: "Site e-commerce",
  date: "Janvier 2024 - Mars 2024",
  description:
    "Développement d'un site web e-commerce pour la vente de t-shirts, pulls, et tote bags personnalisés. L'application gère l'inventaire, les paiements en ligne et propose une interface utilisateur moderne et intuitive.",
  image: "/images/totebag.png",
  tags: ["React", "Symfony", "TailwindCSS", "PostgresSQL"],
  category: "web app",
  github: "https://github.com/amine-aitmokhtar/ecommerce_totebag-dz",
  webapp: "https://netlify_totebag.dz",
},

{
  id: 3,
  title: "AlgeriaTourTrip",
  date: " juillet 2023 - Septembre 2023",
  description:
  "AlgeriaTourTrip est une application web conçue pour promouvoir le tourisme en Algérie. Elle offre aux utilisateurs des informations sur diverses destinations touristiques, sites culturels, hôtels, restaurants, et autres. L'application vise à encourager le tourisme, tant domestique qu'international, en mettant en valeur la beauté et la diversité de l'Algérie.",
  image: "/images/algeria.png", 
  tags: ["React", "CSS","MongoDB"],
  category: "web app",
  github: "https://github.com/amine-aitmokhtar/Tourism_algeria",
},
  { 
    id: 4,
    title: "DiaPredict",
    date: "Octobre 2022 - Mars 2023",
    description:
      "Développement d'un modèle prédictif pour évaluer les risques de diabète. Ce projet a amélioré les outils de diagnostic préventif en utilisant des algorithmes de machine learning pour prédire les risques de diabète chez les patients, basé sur des données médicales.",
    image: "/images/DiaPredict.png", // Utilise le bon chemin d'accès pour les images locales
    tags: ["Python", "Scikit-learn", "Numpy", "Tkinter", "MySQL"],
    category: "machine learning",
    github: "https://github.com/amine-aitmokhtar/DiaPredict",
  },

  {
    id: 5,
    title: "Théorie des graphes",
    date: "Janvier 2022 - Avril 2022",
    description:
    "Développement d'une application en théorie des graphes, implémentant la résolution du problème du voyageur de commerce. Le projet intègre les concepts théoriques vus en cours, notamment le parcours hamiltonien et le parcours eulérien. De plus, des algorithmes de plus court chemin, tels que Dijkstra et Bellman-Ford, ont été codés pour optimiser la recherche des solutions. Cette application offre une visualisation interactive des graphes et des solutions optimisées aux problèmes de chemins",    
      image: "/images/graphe.png", 
      tags: ["Matlab"],
    category: "android app",
    github: "https://github.com/amine-aitmokhtar/Theorie_des_graphes",
  },
  {
    id: 6,
    title: "Le FrançaisFacile",
    date: "Novembre 2022 - Février 2023",
    description:
      "Développement d'une application d'apprentissage de la langue française, avec intégration de fonctionnalités d'analyse de progression des utilisateurs. L'application offre des exercices interactifs et des tests pour améliorer la maîtrise du français.",
      image: "/images/Francais_Facile.png", 
      tags: ["Java", "Spring Boot", "JPA", "SQL"],
    category: "android app",
    github: "https://github.com/amine-aitmokhtar/LeFrancaisFacile_JAVA_DESKTOP",
  },
  {
    id: 7,
    title: "Weather Data Warehouse",
    date: "Mars 2024 - Mai 2024",
    description:
      "Ce projet vise à transformer des données climatiques initialement non organisées et complexes en un entrepôt de données bien structuré et optimisé. Les données brutes, telles que les températures, les précipitations, la vitesse du vent et autres indicateurs météorologiques, sont collectées, nettoyées, transformées et ensuite stockées dans une base de données en utilisant un modèle structuré.",
      image: "/images/dash.jpg", 
      tags: ["Python", "Dash"],
    category: "web app",
    github: "https://github.com/amine-aitmokhtar/WeatherDataWarehouse-Dash",
  },
  
  {
    id: 8,
    title: "QR Code Scanner",
    date: "Avril 2022 - Mai 2022",
    description:
      "Event Manager Mobile App est une application mobile développée en React qui permet de gérer les participants d'événements et de gérer leur accès aux différentes salles et workshops. Cette application simplifie l'organisation des événements en fournissant une interface intuitive pour le suivi des participants et la gestion des accès.",
      image: "/images/qrcode.png", 
      tags: ["React", "CSS","mySQL"],
    category: "web app",
    github: "https://github.com/amine-aitmokhtar/QRCodeScanner",
  },
  
];

